<template>
  <div class="phone-index-wrapper">
    <div class="swiper-box">
      <swiper-wrapper></swiper-wrapper>
    </div>
    <banner></banner>
    <jinr-important></jinr-important>
    <mid-tab></mid-tab>
    <news></news>
    <partner></partner>
    <Mfooter />
  </div>
</template>
<script>
import SwiperWrapper from './components/swiper';
import Banner from './components/banner';
import JinrImportant from './components/jinr-important';
import MidTab from './components/mid-tab';
import News from './components/news';
import Partner from './components/partner';
import Mfooter from '@/components/m-footer';
export default {
  name: 'phone-index',
  components: {
    SwiperWrapper,
    Banner,
    JinrImportant,
    MidTab,
    News,
    Partner,
    Mfooter
  }
};
</script>
<style lang="less" scoped>
.phone-index-wrapper {
  text-align: center;
  height: calc(100vh - 0.83rem);
  overflow-y: auto;
  .swiper-box {
    height: 3.26rem;
  }
}
</style>
